/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_CodeInputs */

const id_staff_code = /** @type {(inputs: Staff_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode autentikator`)
};

const en_staff_code = /** @type {(inputs: Staff_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticator code`)
};

/**
* | output |
* | --- |
* | "Authenticator code" |
*
* @param {Staff_CodeInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_code = /** @type {((inputs?: Staff_CodeInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_CodeInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_code(inputs)
	return id_staff_code(inputs)
});